var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLeftHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 240,
    viewBox: "0 0 157 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.3418 93.5722C75.8582 42.711 22.2614 75.3598 35.0013 62.6011L15.8773 81.7249C6.01545 91.5895 0.323815 105.623 0.212891 120C0.323815 134.377 6.01545 148.411 15.8773 158.274L34.9908 177.389C22.2644 164.632 28.6426 145.51 41.3929 132.758L54.1508 120L79.3418 93.5722Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3934 132.758L54.1513 119.999L156.211 222.066C137.075 241.204 105.181 247.582 86.0451 228.445L35.0153 177.411L34.9913 177.389C22.2649 164.632 28.6431 145.509 41.3934 132.758Z",
    fill: "url(#paint0_linear_3027_16611)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.213 17.9339C137.077 -1.20346 105.183 -7.58207 86.0467 11.5553L35.0169 62.5872L35.0049 62.5977L35.0034 62.6007C22.2635 75.3595 28.6417 94.4878 41.395 107.242L54.1529 119.999L156.213 17.9339Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3027_16611",
    x1: 164.458,
    y1: -0.000351425,
    x2: 164.458,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1D3645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeftHalf);
export default __webpack_public_path__ + "static/media/logo-left-half.0c23054c9e3cc4904c8b1a6e3dfcb407.svg";
export { ForwardRef as ReactComponent };